import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronUpFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m10.25,8.5c-.192,0-.384-.073-.53-.22l-3.72-3.72-3.72,3.72c-.293.293-.768.293-1.061,0s-.293-.768,0-1.061L5.47,2.97c.293-.293.768-.293,1.061,0l4.25,4.25c.293.293.293.768,0,1.061-.146.146-.338.22-.53.22Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconChevronUpFill12.js.map